
import { supabase } from '@/lib/supabase';
import { adminLog, adminError } from '@/lib/utils/admin-logger';

// Function to ensure the PaperVerseBot exists in the database and return its ID
export const ensureBotUserExists = async (): Promise<string | null> => {
  try {
    // Try to get the bot from the bots table directly
    const { data: existingBots, error: checkError } = await supabase
      .from('bots')
      .select('id')
      .eq('name', 'PaperVerseBot')
      .limit(1);
      
    if (checkError) {
      adminError('Error checking for bot:', checkError);
      return null;
    }
    
    if (existingBots && existingBots.length > 0) {
      adminLog('PaperVerseBot exists with ID:', existingBots[0].id);
      return existingBots[0].id;
    }
    
    // As a last resort, try to create the bot
    const { data: newBot, error: insertError } = await supabase
      .from('bots')
      .insert({
        name: 'PaperVerseBot',
        role: 'AI Assistant',
        institution: 'PaperVerse'
      })
      .select('id')
      .single();
      
    if (insertError) {
      adminError('Error creating bot:', insertError);
      return null;
    }
    
    adminLog('Created new PaperVerseBot with ID:', newBot.id);
    return newBot.id;
  } catch (error) {
    adminError('Unexpected error ensuring bot user exists:', error);
    return null;
  }
};

// New helper function to identify if a user ID belongs to a bot
export const isBotReviewer = async (reviewerId: string): Promise<boolean> => {
  try {
    const { data, error } = await supabase
      .from('bots')
      .select('id')
      .eq('id', reviewerId)
      .limit(1);
      
    if (error) {
      console.error('Error checking if reviewer is bot:', error);
      return false;
    }
    
    return data && data.length > 0;
  } catch (error) {
    console.error('Error in isBotReviewer:', error);
    return false;
  }
};
